export class Tag {
    tag_id: number;
    name: string;
    description: string;
    status: any;
    category: string;
}
